"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = void 0;
const httpError_1 = require("../errors/httpError");
require('es6-promise').polyfill();
require('isomorphic-fetch');
const defaultHeaders = {
    'accept': 'application/json',
    'connection': 'keep-alive',
    'content-type': 'application/json'
};
class ApiClient {
    constructor(configuration, headers) {
        this.callApi = (method, api, data, headers) => __awaiter(this, void 0, void 0, function* () { return yield this.callCustomApi(method, this.configuration.apiUrl + '/' + api, data, headers); });
        this.callCustomApi = (method, url, data, headers) => __awaiter(this, void 0, void 0, function* () {
            return yield fetch(url, this.buildRequest(method, data, headers))
                .then(res => {
                if (res.ok)
                    return res.json();
                else
                    throw new httpError_1.HttpError(res.statusText, res.status);
            });
        });
        this.buildRequest = (method, data, headers) => ({
            method,
            headers: Object.assign(Object.assign({}, this.headers), headers),
            body: JSON.stringify(data)
        });
        this.configuration = configuration;
        this.headers = Object.assign(Object.assign({}, defaultHeaders), headers);
    }
}
exports.ApiClient = ApiClient;
exports.default = ApiClient;
